import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export const ZapierIcon = (param)=>{
    let { size = 24, testId, style, className } = param;
    return /*#__PURE__*/ _jsx("svg", {
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        style: style,
        className: className,
        children: /*#__PURE__*/ _jsx("path", {
            d: "M12.01 1.53002C12.6 1.53002 13.19 1.58002 13.75 1.68002V7.79002L18.08 3.47002C18.56 3.81002 19.01 4.19002 19.42 4.60002C19.83 5.01002 20.21 5.46002 20.56 5.94002L16.23 10.26H22.36C22.46 10.83 22.51 11.41 22.51 12C22.51 12.61 22.46 13.19 22.36 13.75H16.23L20.57 18.07C20.23 18.55 19.85 19 19.44 19.41C19.03 19.82 18.58 20.2 18.1 20.54L13.76 16.22V22.33C13.19 22.42 12.61 22.47 12.02 22.48H12C11.41 22.48 10.83 22.43 10.26 22.33V16.22L5.93 20.54C4.97 19.86 4.14 19.03 3.45 18.07L7.78 13.75H1.65C1.55 13.18 1.5 12.6 1.5 12.01V11.98C1.5 11.83 1.51 11.64 1.53 11.44V11.38C1.58 10.83 1.65 10.26 1.65 10.26H7.78L3.44 5.93002C3.78 5.45002 4.16 5.01002 4.57 4.59002C4.98 4.17002 5.43 3.80002 5.91 3.46002L10.24 7.78002V1.67002C10.81 1.58002 11.39 1.53002 11.98 1.52002H11.99L12.01 1.53002ZM12.01 9.38002H12C11.22 9.38002 10.47 9.52002 9.78 9.78002C9.52 10.47 9.38 11.21 9.38 11.99C9.38 12.78 9.52 13.52 9.78 14.21C10.47 14.47 11.22 14.61 12 14.61H12.01C12.79 14.61 13.54 14.47 14.23 14.21C14.49 13.52 14.63 12.78 14.63 12C14.63 11.21 14.49 10.47 14.23 9.78002C13.54 9.52002 12.79 9.38002 12.01 9.38002Z",
            fill: "#FF4A00"
        })
    });
};
